import { Link } from "react-router-dom";
import { motion } from "framer-motion";
export default function EmploymentLaw() {
  return (
       <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Employment Law</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
    If you are an employee who has been formally terminated without proper notice (wrongful dismissal) or pushed out by significant changes to your job (constructive dismissal), you may be entitled to compensation under Alberta Employment Law.
At our firm, we help employees understand their rights, evaluate their situation, and act if their dismissal was unfair or unlawful.
We assist clients by reviewing facts respecting termination or workplace changes, determining if any of their rights have been violated, advising on severance offers, pursuing fair compensation through negotiation or legal action.
Book an appointment with us to obtain advice regarding any workplace challenges that you might be facing.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>

    </motion.div>
  );
}
